import api from "./api";

const bookingService = {
  createBookingInit: (data) => api.post("/bookings/init-intent", data),
  createBooking: (data) => api.post("/bookings", data),
  getMyBookings: (params) => api.get("/bookings/my", { params }),
  getBooking: (id) => api.get(`/bookings/${id}`),
  cancelBooking: (id, reason) =>
    api.patch(`/bookings/${id}/cancel`, { reason }),
};

export default bookingService;
